import { render, staticRenderFns } from "./priceDistro.vue?vue&type=template&id=ea80a450&scoped=true"
import script from "./priceDistro.vue?vue&type=script&lang=js"
export * from "./priceDistro.vue?vue&type=script&lang=js"
import style0 from "./priceDistro.vue?vue&type=style&index=0&id=ea80a450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea80a450",
  null
  
)

export default component.exports